import React from "react";
import {
  Container,
  Typography,
  Box,
  List,
  ListItem,
  Link,
} from "@mui/material";

const ReturnsPolicy = () => {
  return (
    <Container maxWidth="md" sx={{ py: 6 }}>
      <Typography variant="h4" align="center" gutterBottom>
        Returns & Refunds Policy
      </Typography>

      <Box my={3}>
        <Typography variant="h6">Cancellation Period</Typography>
        <Typography paragraph>
          You may cancel your order within 30 days of receiving the goods, without providing any reason.
        </Typography>
        <Typography paragraph>The cancellation period ends 30 days from the date:</Typography>
        <List>
          <ListItem>You received the goods, or</ListItem>
          <ListItem>A third party (not the carrier) appointed by you takes possession of the goods.</ListItem>
        </List>
      </Box>

      <Box my={3}>
        <Typography variant="h6">How to Cancel</Typography>
        <Typography paragraph>
          To cancel, you must inform us clearly via email at:{" "}
          <Link href="mailto:info@econirmit.com">info@econirmit.com</Link>
        </Typography>
      </Box>

      <Box my={3}>
        <Typography variant="h6">Refund Process</Typography>
        <Typography paragraph>
          Refunds will be processed within 30 days of receiving the returned goods.
        </Typography>
        <Typography paragraph>
          The refund will be made using the same payment method used during the purchase.
        </Typography>
        <Typography paragraph>
          No additional fees will be charged for the refund.
        </Typography>
      </Box>

      <Box my={3}>
        <Typography variant="h6">Conditions for Return</Typography>
        <Typography paragraph>To be eligible for a return:</Typography>
        <List>
          <ListItem>Goods must have been purchased within the last 30 days.</ListItem>
          <ListItem>Goods must be in their original packaging.</ListItem>
        </List>
      </Box>

      <Box my={3}>
        <Typography variant="h6">Non-Returnable Items</Typography>
        <Typography paragraph>The following items cannot be returned:</Typography>
        <List>
          <ListItem>Goods made to your specifications or clearly personalized.</ListItem>
          <ListItem>Goods that deteriorate quickly or are past their expiry date.</ListItem>
          <ListItem>Goods unsealed after delivery and not suitable for return due to health or hygiene reasons.</ListItem>
          <ListItem>Goods that, after delivery, are inseparably mixed with other items.</ListItem>
        </List>
        <Typography paragraph>
          <strong>Note:</strong> We reserve the right to reject returns that do not meet the above conditions.
        </Typography>
      </Box>

      <Box my={3}>
        <Typography variant="h6">Returning Goods</Typography>
        <Typography paragraph>
          You are responsible for the cost and risk of returning the goods.
        </Typography>
        <Typography paragraph>
          Returns must be sent to the address on our website:{" "}
          <Link href="https://econirmit.com/" target="_blank" rel="noopener">
            https://econirmit.com/
          </Link>
        </Typography>
        <Typography paragraph>
          We are not liable for goods damaged or lost in return transit.
        </Typography>
        <Typography paragraph>
          Use an insured and trackable mail service.
        </Typography>
        <Typography paragraph>
          Refunds will not be issued without receipt of goods or proof of return delivery.
        </Typography>
      </Box>

      <Box my={3}>
        <Typography variant="h6">Gifts</Typography>
        <Typography paragraph>If marked as a gift at the time of purchase and shipped directly to you:</Typography>
        <List>
          <ListItem>You will receive a gift credit for the value of your return.</ListItem>
          <ListItem>A gift certificate will be issued after receiving the return.</ListItem>
        </List>
        <Typography paragraph>
          If not marked as a gift, or if the order was shipped to the gift giver:
        </Typography>
        <List>
          <ListItem>The refund will be issued to the gift giver.</ListItem>
        </List>
      </Box>

      <Box my={3}>
        <Typography variant="h6">Contact Us</Typography>
        <Typography paragraph>
          For any queries regarding this policy, email us at:{" "}
          <Link href="mailto:info@econirmit.com">info@econirmit.com</Link>
        </Typography>
      </Box>
    </Container>
  );
};

export default ReturnsPolicy;
